import { IdvChannel } from '../../components/molecules/identity-verification/types'
import { TemplateIdTypes } from '../../components/molecules/persona-client'
import { COUNTRY_SHORTCODES } from '../../constants'
import { IDVStatus } from '../steps'
import { TemplateIds } from './templates'

const isResumingInquiry = (
  vehicleType: string,
  inquiryId: string,
  idvStatus: string,
  idvTemplateId: string,
  isIDVReferral: boolean,
  country: keyof typeof COUNTRY_SHORTCODES
): boolean => {
  if (country === COUNTRY_SHORTCODES.US) {
    const channel = isIDVReferral
      ? IdvChannel.REFERRAL
      : IdvChannel.NON_REFERRAL
    if (
      TemplateIdTypes['non-motorized'].includes(idvTemplateId) &&
      TemplateIdTypes.motorized.includes(TemplateIds[channel][vehicleType])
    ) {
      return false
    }
  }

  return Boolean(inquiryId) && idvStatus !== IDVStatus.APPROVED
}

export default isResumingInquiry
